module.exports = __webpack_public_path__ + "img/icon-stocks-big.1e7bebf0.svg";